import { colorSystem, generateThemeObjects } from './colorSystem';

export const contentData = {
  hero: {
    tag: "Chicago's LGBTQ+ news source since 1985",
    title: "Connect with\nChicago's LGBTQ+\nCommunity",
    description: "Reach progressive professionals, community advocates, and decision-makers through Chicago's most trusted LGBTQ+ news source.",
    ctaText: "Advertise with us",
    stats: [
      { key: "120K", value: "Monthly Visitors" },
      { key: "42K+", value: "Social Followers" },
      { key: "10K+", value: "Newsletter Subscribers" }
    ]
  },
  
  audience: {
    title: "Your next customers: Chicago's LGBTQ+ community",
    description: "Our audience represents Chicago's most engaged LGBTQ+ professionals—decision-makers with disposable income and community influence. With 120,000 monthly website visitors, 10,000+ newsletter subscribers, and 42,000+ social media followers, we deliver the authentic connection your brand needs.",
    brandStrengths: {
      title: "Why advertisers choose us",
      items: [
        "Strong brand loyalty",
        "Deep understanding of the LGBTQ+ community",
        "Established trust and reputation",
        "Community support",
        "High-potential for growth in the all-digital realm"
      ]
    },
    communityImpact: {
      title: "Who we impact",
      items: [
        "LGBTQ+ community & their families",
        "Event organizers & local leaders",
        "Allies & changemakers",
        "Local economy (non-profits & for-profits)"
      ]
    },
    lifestyleInsights: [
      { icon: "tv", value: "90%+", label: "Engaged Media Consumers", description: "Stream TV and entertainment content" },
      { icon: "utensils", value: "70%+", label: "Social & Active", description: "Regularly dine out and attend events" },
      { icon: "plane", value: "80%+", label: "Travel Enthusiasts", description: "Plan U.S. travel annually" },
      { icon: "mail", value: "54%", label: "Highly Engaged", description: "Newsletter open rate" }
    ]
  },

  testimonials: {
    title: "Community voice",
    communityQuote: {
      quote: "As a newly out transgender woman, I'm looking for guidance on how to newly connect with the LGBTQIA+ community in Chicago, particularly (but not exclusively) with fellow trans individuals...Thank you very much for the newsletter, it's going to be wonderfully helpful.",
      attribution: "Chicago Social Butterflies subscriber"
    },
    recognition: {
      year: "2020",
      title: "Chicago LGBT Hall of Fame",
      description: "Inducted for decades of service"
    }
  },

  inventory: {
    title: "Advertise with us",
    description: "Reach Chicago's LGBTQ+ community through our comprehensive digital platform and engaged newsletter subscribers.",
    tabs: [
      {
        id: "website",
        label: "Website display",
        isActive: true,
        title: "Premium website advertising",
        description: "Connect with 120,000+ monthly visitors through premium ad placements on windycitytimes.com – Chicago's leading LGBTQ+ news destination.",
        stats: [
          { value: "Billboard", label: "970x250 - $1,000/mo" },
          { value: "Leaderboard", label: "728x90 - $1,000/mo" },
          { value: "Rectangle", label: "300x250 - $500/mo" },
          { value: "Filmstrip", label: "300x600 - $700/mo" }
        ]
      },
      {
        id: "newsletters",
        label: "Email newsletters",
        isActive: true,
        title: "Newsletter advertising",
        description: "Reach engaged subscribers through our suite of newsletters including News on Q (45% open rate) and Chicago Social Butterflies (54% open rate).",
        stats: [
          { value: "News on Q", label: "5,000 subscribers weekly" },
          { value: "Social Butterflies", label: "54% open rate" },
          { value: "BLACKlines", label: "Black LGBTQ+ community" },
          { value: "En La Vida", label: "Latino LGBTQ+ community" }
        ]
      },
      {
        id: "sponsored",
        label: "Sponsored content",
        isActive: true,
        title: "Native & sponsored content",
        description: "Custom content creation that authentically connects your brand with our LGBTQ+ readership through editorial-style storytelling.",
        stats: [
          { value: "Custom", label: "Content creation available" },
          { value: "Native", label: "In-content placement" },
          { value: "Editorial", label: "Professional writing" },
          { value: "Reach", label: "900K monthly impressions" }
        ]
      },
      {
        id: "events",
        label: "Event sponsorships",
        isActive: true,
        title: "40th anniversary events",
        description: "Align your brand with our milestone 40th anniversary celebration throughout 2025 – premium visibility with Chicago's LGBTQ+ community.",
        stats: [
          { value: "Title", label: "$5,000 sponsorship" },
          { value: "Presenting", label: "$2,500 sponsorship" },
          { value: "Supporting", label: "$1,000 sponsorship" },
          { value: "Attendees", label: "200+ per event" }
        ]
      }
    ]
  },

  campaign: {
    title: "Build your campaign",
    description: "Connect with Chicago's LGBTQ+ community through trusted journalism and authentic community engagement.",
    steps: [
      {
        number: "01",
        title: "Tell us your goals",
        description: "Share your brand story, target audience, and campaign objectives. We'll listen.",
        icon: "chat"
      },
      {
        number: "02",
        title: "Get a custom plan",
        description: "Receive a tailored campaign strategy with recommended formats and reach estimates.",
        icon: "lightbulb"
      },
      {
        number: "03",
        title: "We build and run it",
        description: "Our team handles everything—media buying, creative coordination, and performance tracking.",
        icon: "rocket"
      }
    ],
    ctaText: "Get started"
  },

  contactFAQ: {
    contactTitle: "Get in touch",
    contactDescription: "Let's create your campaign together!",
    contactInfo: {
      phone: "(773) 871-7610",
      email: "terri@windycitymediagroup.com",
      address: "5315 N Clark St, Suite 192, Chicago, IL 60640"
    },
    faqTitle: "FAQs",
    faqItems: [
      {
        question: "What makes Windy City Times unique?",
        answer: "We're Chicago's only LGBTQ+ news source with a 40-year legacy – established trust, community loyalty, and award-winning journalism that readers rely on."
      },
      {
        question: "What advertising formats do you offer?",
        answer: "We offer website display ads (billboard, leaderboard, rectangle, filmstrip), newsletter placements, sponsored content, and event sponsorships."
      },
      {
        question: "What are your minimum commitments?",
        answer: "Most digital advertising requires a 4-week minimum commitment. Event sponsorships and custom packages vary – contact us for details."
      },
      {
        question: "What's your audience demographic?",
        answer: "120,000+ monthly visitors and 42,000+ social media followers. Our readers are LGBTQ+ individuals, allies, progressive professionals, and community advocates across Chicago."
      },
      {
        question: "Do you offer package discounts?",
        answer: "Yes! We offer multi-platform discounts when you combine website, newsletter, and social media advertising. Contact us for custom package pricing."
      },
      {
        question: "What's your lead time for campaigns?",
        answer: "We require 5 business days minimum lead time and materials 3 business days prior to publication. Rush placements may be available – contact us."
      }
    ]
  },

  aboutUs: {
    title: "40 years of LGBTQ+ journalism",
    description: "Windy City Media Group has been Chicago's trusted LGBTQ+ news source since 1985. Our award-winning journalism covers local politics, community events, arts and culture, healthcare, and social justice issues that matter to Chicago's LGBTQ+ community. Led by Executive Editor Andrew Davis and Publisher Terri Klinsky, our team includes veteran journalists like Matt Simonette, Rex Wockner, and Richard Knight Jr. We've earned recognition from the National Lesbian and Gay Journalists Association, Chicago Headline Club, and induction into the Chicago LGBT Hall of Fame. As we celebrate our 40th anniversary in 2025, we continue our mission: informing, inspiring, and advocating for Chicago's LGBTQ+ community.",
    imageUrl: "/images/aboutus-rainbow.jpg"
  },

  footer: {
    contactInfo: {
      phone: "(773) 871-7610",
      email: "terri@windycitymediagroup.com", 
      address: "5315 N Clark St, Suite 192, Chicago, IL 60640"
    },
    socialLinks: {
      linkedin: "https://facebook.com/WindyCityTimes",
      twitter: "https://twitter.com/WindyCityTimes",
      facebook: "https://facebook.com/WindyCityTimes"
    },
    companyName: "Windy City Media Group",
    description: "Chicago's trusted LGBTQ+ news source since 1985"
  }
};

export const themeData = {
  // Design system values
  gradStart: colorSystem.darkGradient.start,
  gradEnd: colorSystem.darkGradient.end,
  angle: colorSystem.darkGradient.angle,
  fontFamily: "primary",
  radius: 4,
  iconWeight: "duotone",
  
  // Assets
  heroImages: {
    desktop: `/images/hero-desktop.jpg?v=${Date.now()}`,
    mobile: '/images/hero-mobile.jpg'
  },
  logoUrl: `/images/wcmlogo-white.webp?v=${Date.now()}`,
  
  // Navigation
  navItems: [
    { id: "audience", label: "Our Audience", href: "#audience" },
    { id: "advertise", label: "Advertise", href: "#inventory" },
    { id: "aboutus", label: "About", href: "#aboutus" }
  ],
  ctaText: "Contact",
  ctaHref: "#contactfaq",
  
  // Section settings
  sectionSettings: {
    hero: { surface: "white", primary: "light" },
    audience: { surface: "light", primary: "light" },
    testimonials: { surface: "dark", primary: "dark" },
    inventory: { surface: "light", primary: "light" },
    campaign: { surface: "dark", primary: "dark" },
    contactfaq: { surface: "light", primary: "light" },
    aboutus: { surface: "light", primary: "light" },
    footer: { surface: "dark", primary: "dark" }
  },
  
  // Theme colors - now generated from centralized system
  ...generateThemeObjects()
};
